export const bulkImportsHistoryPageTexts = {
  BACK_TO_SOFT_TAGS_SEARCH: 'Back to Soft Tags Listing',
  BULK_IMPORTS_HISTORY: 'Imports history',
  TRACK_AND_REVIEW_BULK_SOFT_TAG_IMPORTS:
    'Listing of bulk import for adding new soft tags',
};

export type BulkImportStatus =
  | 'Complete'
  | 'Rejected'
  | 'Partial Reject'
  | 'Processing';
export type BulkImportFileStatus =
  | 'FAILED'
  | 'COMPLETED'
  | 'PARTIAL_CREATED'
  | 'PROCESSING'
  | string;

export interface BulkImportHistoryItem {
  id: number;
  fileName: string;
  originalFileName: string;
  uploadedBy: string;
  fileSizeBytes: number;
  contentType: string;
  checksumSha256: string;
  uploadedAt: string;
  updatedAt: string;
  totalRows: number;
  status: BulkImportStatus;
  rawStatus: BulkImportFileStatus;
  createdRows: number;
  failedRows: number;
  inProgress?: boolean;
  errorFilePresent: boolean;
}

export type BulkImportFilesParams = {
  status?: string;
  start_time?: string;
  end_time?: string;
  page?: number;
  size?: number;
};

export interface BulkImportFileDTO {
  id: number;
  file_name: string;
  original_file_name: string;
  content_type: string;
  file_size_bytes: number;
  checksum_sha256: string;
  uploaded_by: string;
  status: BulkImportFileStatus;
  total_rows: number;
  valid_rows: number;
  invalid_rows: number;
  created_at: string;
  updated_at: string;
  error_file_present: boolean;
}

export interface BulkImportFilesListResponseDTO {
  total_count: number;
  page: number;
  size: number;
  data: BulkImportFileDTO[];
}

export type BulkImportFilesResponse = {
  results: BulkImportHistoryItem[];
  count: number;
  page: number;
  size: number;
};
